import Panel from '@/views/Login/Panel.vue'
import router from '@/router'
import { verifyUser } from '@/utils/requestHandler'

export default {
   name: 'Confirm',
   components: {
      Panel
   },
   data() {
      return {
         confirmed: false,
         confirmError: '',
         emailConfirmed: false,
         smsConfirmed: false
      }
   },
   methods: {
      async confirmUser() {
         console.log(this.$route.params.id)
         await verifyUser(this.$route.params.id)
            .then(resp => {
               this.confirmed = true
               if (resp.data.includes('Email')) {
                  this.emailConfirmed = true
               } else if (resp.data.includes('Phone number')) {
                  this.smsConfirmed = true
               } else {
                  this.emailConfirmed = this.smsConfirmed = true
               }
               console.log(resp)
            })
            .catch(err => {
               console.log(err.response)
               if (err.response.data.includes('Email')) {
                  this.confirmError = 'emailAlreadyConfirmed'
               } else if (err.response.data.includes('SMS')) {
                  this.confirmError = 'smsAlreadyConfirmed'
               } else {
                  this.confirmError = 'notFound'
               }
            })
      },
      login() {
         router.push({ name: 'Login' })
      },
      signUp() {
         router.push({ name: 'SignUp' })
      }
   }
}
